// gameList/actionTypes.js

const REQUEST_GAME_DATA = '@@gameList/REQUEST_GAME_DATA';
const GAME_DATA_RESPONSE = '@@gameList/GAME_DATA_RESPONSE';
const HEADER_GAME_DATA_RESPONSE = '@@gameList/HEADER_GAME_DATA_RESPONSE';
const PURGE_GAME_DATA = '@@gameList/PURGE_GAME_DATA';
const REQUEST_BOXSCORE_DATA = '@@gameList/REQUEST_BOXSCORE_DATA';
const BOXSCORE_DATA_RESPONSE = '@@gameList/BOXSCORE_DATA_RESPONSE';
const SET_RETAIN_BOXSCORE_DATA_ID = '@@gameList/SET_RETAIN_BOXSCORE_DATA_ID';
const REQUEST_GAME_DATE = '@@gameList/REQUEST_GAME_DATE';
const GAME_DATE_RESPONSE = '@@gameList/GAME_DATE_RESPONSE';
const REQUEST_LANDING_DATA = '@@gameList/REQUEST_LANDING_DATA';
const LANDING_DATA_RESPONSE = '@@gameList/LANDING_DATA_RESPONSE';
const REQUEST_RIGHT_RAIL_DATA = '@@gameList/REQUEST_RIGHT_RAIL_DATA';
const RIGHT_RAIL_DATA_RESPONSE = '@@gameList/RIGHT_RAIL_DATA_RESPONSE';

export default {
    REQUEST_GAME_DATA,
    GAME_DATA_RESPONSE,
    HEADER_GAME_DATA_RESPONSE,
    PURGE_GAME_DATA,
    REQUEST_BOXSCORE_DATA,
    BOXSCORE_DATA_RESPONSE,
    SET_RETAIN_BOXSCORE_DATA_ID,
    REQUEST_GAME_DATE,
    GAME_DATE_RESPONSE,
    REQUEST_LANDING_DATA,
    LANDING_DATA_RESPONSE,
    REQUEST_RIGHT_RAIL_DATA,
    RIGHT_RAIL_DATA_RESPONSE
};
